import type { ReactNode } from 'react';

export const symbol_night_shelter: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-120q-24.75 0-42.37-17.63Q160-155.25 160-180v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q15.68-12 35.84-12Q500-825 516-813l260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v390q0 24.75-17.62 42.37Q764.75-120 740-120H220Zm0-60h520v-394L480-763 220-574v394Zm260-292ZM320-300h320v40q0 8 6 14t14 6q8 0 14-6t6-14v-140q0-33-23.5-56.5T600-480H490q-12.75 0-21.37 8.62Q460-462.75 460-450v110H320v-160q0-8-6-14t-14-6q-8 0-14 6t-6 14v240q0 8 6 14t14 6q8 0 14-6t6-14v-40Zm105.5-74.5Q440-389 440-410t-14.5-35.5Q411-460 390-460t-35.5 14.5Q340-431 340-410t14.5 35.5Q369-360 390-360t35.5-14.5Z"
		/>
	</svg>
);
